import React from 'react';
import EnumInput from '../../../../misc/EnumInput';
import { CoreTeamsFixArchivedSettings, GroupSettings, SharePointSiteSettings, ArchivedSettingBehaviour } from '../../../../../models/TeamsFixTypes';
import { useTranslation } from 'react-i18next';

interface TeamsFixArchivedSettingsProps {
    teamsFixSettings: CoreTeamsFixArchivedSettings
    disabled: boolean
    onChange: (x: CoreTeamsFixArchivedSettings) => void
    name: string
}

const TeamsFixArchivedSettingsComponent: React.FC<TeamsFixArchivedSettingsProps> = (props) => {
    const { t } = useTranslation(['configuration']);

    const settings = props.teamsFixSettings;

    const notifyChange = (change: Partial<CoreTeamsFixArchivedSettings>) => props.onChange({
        ...settings,
        ...change
    });

    return (<>
        <EnumInput
            title={t('oneRosterConfiguration.teamsFix.settings.archivedSettingsBehaviour.title', { ns: 'configuration' })}
            name={props.name + ".settingsBehaviour"}
            value={settings.settingBehaviour}
            options={ArchivedSettingBehaviour.map(x => ({ value: x, text: t(`oneRosterConfiguration.teamsFix.settings.archivedSettingsBehaviour.options.${x}`, { ns: 'configuration' }) }))}
            onChange={(n, v) => notifyChange({ settingBehaviour: v })}
            disabled={props.disabled}
            multi={false}
        />

        <EnumInput
            title={t('oneRosterConfiguration.teamsFix.settings.sharePointSiteSettings.title', { ns: 'configuration' })}
            name={props.name + ".sharePointSiteSettings"}
            value={settings.sharePointSiteSettings}
            options={SharePointSiteSettings.map(x => ({ value: x, text: t(`oneRosterConfiguration.teamsFix.settings.sharePointSiteSettings.options.${x}`, { ns: 'configuration' }) }))}
            onChange={(n, v) => notifyChange({ sharePointSiteSettings: v })}
            disabled={props.disabled}
            multi={true}
        />

        <EnumInput
            title={t('oneRosterConfiguration.teamsFix.settings.groupSettings.title', { ns: 'configuration' })}
            name={props.name + ".groupSettings"}
            value={settings.groupSettings}
            options={GroupSettings.map(x => ({ value: x, text: t(`oneRosterConfiguration.teamsFix.settings.groupSettings.options.${x}`, { ns: 'configuration' }) }))}
            onChange={(n, v) => notifyChange({ groupSettings: v })}
            disabled={props.disabled}
            multi={true}
        />
    </>);
}

export default TeamsFixArchivedSettingsComponent;
